/**
 * Um pedaço da tela que sumiu no deploy: recarrega uma vez (F212).
 *
 * Cada deploy troca os arquivos de `/assets`, e uma aba aberta desde antes
 * pede um pedaço que não existe mais (o 404 de `tanstack-BbZc7XDG.js` em
 * 29/09) — a tela ficava em branco no meio do uso. O Vite avisa com
 * `vite:preloadError`; aqui a página recarrega UMA vez, e só volta a tentar
 * depois de um minuto, para nunca virar um laço.
 */

const KEY = 'aeris.stale-chunk-reload'
const AGAIN_AFTER_MS = 60_000

type Storage = Pick<globalThis.Storage, 'getItem' | 'setItem'>

export const reloadOnceForStaleChunk = (
  event: Event,
  storage: Storage | null = safeSession(),
  reload: () => void = () => {
    window.location.reload()
  },
  now: number = Date.now()
): boolean => {
  const last = Number(storage?.getItem(KEY) ?? '0')
  if (last > 0 && now - last < AGAIN_AFTER_MS) return false
  storage?.setItem(KEY, String(now))
  event.preventDefault()
  reload()
  return true
}

const safeSession = (): Storage | null => {
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

export const listenForStaleChunks = (): void => {
  window.addEventListener('vite:preloadError', (event) => {
    reloadOnceForStaleChunk(event)
  })
}
